import { useState, useEffect, useCallback } from "react";

const STORAGE_KEY = 'entidadTokenAuth';

export const useEntidadTokenAuth = () => {
    const [entidadSession, setEntidadSession] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // Cargar sesión de sessionStorage al montar
    useEffect(() => {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                // Verificar si el token no ha expirado (7 días desde createdAt)
                const createdAt = new Date(parsed.createdAt);
                const now = new Date();
                const diffDays = (now - createdAt) / (1000 * 60 * 60 * 24);
                
                if (diffDays < 7) {
                    setEntidadSession(parsed);
                } else {
                    // Token expirado, limpiar
                    sessionStorage.removeItem(STORAGE_KEY);
                }
            } catch (e) {
                console.error('Error parsing entidad session:', e);
                sessionStorage.removeItem(STORAGE_KEY);
            }
        }
        setIsLoading(false);
    }, []);

    const loginEntidad = useCallback((token, idRed, entidadData) => {
        const session = {
            token,
            idRed,
            entidadId: entidadData?.entidad_id,
            entidadNombre: entidadData?.entidad_nombre || entidadData?.nombre_institucion,
            email: entidadData?.email,
            createdAt: new Date().toISOString(),
            isEntidadSession: true
        };
        
        setEntidadSession(session);
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
        
        // También guardar individualmente para compatibilidad
        sessionStorage.setItem('entidadToken', token);
        sessionStorage.setItem('entidadIdRed', idRed);
        sessionStorage.setItem('entidadData', JSON.stringify(entidadData));
    }, []);

    const logoutEntidad = useCallback(() => {
        setEntidadSession(null);
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem('entidadToken');
        sessionStorage.removeItem('entidadIdRed');
        sessionStorage.removeItem('entidadData');
    }, []);

    const isEntidadAuthenticated = !!entidadSession;

    return {
        entidadSession,
        isEntidadAuthenticated,
        isLoading,
        loginEntidad,
        logoutEntidad,
        entidadToken: entidadSession?.token,
        entidadIdRed: entidadSession?.idRed,
        entidadNombre: entidadSession?.entidadNombre
    };
};

export default useEntidadTokenAuth;
